
export type ChatRoomListResponsePageAllOfThreeContentItemBasicInfoAllOfTwoType = typeof ChatRoomListResponsePageAllOfThreeContentItemBasicInfoAllOfTwoType[keyof typeof ChatRoomListResponsePageAllOfThreeContentItemBasicInfoAllOfTwoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatRoomListResponsePageAllOfThreeContentItemBasicInfoAllOfTwoType = {
  DIRECT: 'DIRECT',
  GROUP: 'GROUP',
} as const;
